"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class DescribeController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            get: '/v1/describe/_all',
        };
    }
    list() {
        throw new Error("Can't list describe");
    }
    count() {
        throw new Error("Can't count describe");
    }
    create({}) {
        throw new Error("Can't create describe!");
    }
    edit({}) {
        throw new Error("Can't edit describe!");
    }
    delete() {
        throw new Error("Can't delete describe!");
    }
}
exports.default = DescribeController;
